<script setup lang="ts">
  // import { useDropZone } from '@vueuse/core'
  import { ref, useTemplateRef } from 'vue'
  import { useAuthStore } from '@/stores/auth'
  import TheSidebar from './_components/sidebar/the-sidebar.vue'
  import TheFooter from './_components/the-footer.vue'
  import TheNavbar from './_components/the-navbar.vue'
  import TheSearchbox from './_components/the-searchbox.vue'

  const auth = useAuthStore()

  const sidebarShow = ref(false)
  const toggleSidebarShow = () => {
    sidebarShow.value = !sidebarShow.value
  }

  const searchbox = useTemplateRef('searchbox')

  // const refDropZone = ref<HTMLElement>()
  // const { isOverDropZone } = useDropZone(refDropZone)
  // watchEffect(() => {
  //   app.setUserDraggingFile(isOverDropZone.value)
  // })
</script>

<template>
  <div :class="{ 'sidebar-show': sidebarShow }">
    <template v-if="auth.user.id">
      <div class="screen">
        <div class="container px-container pt-4">
          <the-navbar @toggle-sidebar="toggleSidebarShow" />
          <div class="min-h-container">
            <app-router-view />
            <!-- <router-view /> -->
          </div>
          <the-footer />
        </div>
      </div>

      <the-sidebar
        :show="sidebarShow"
        @toggle-sidebar-show="toggleSidebarShow"
        @open-search="searchbox?.open()" />

      <the-searchbox ref="searchbox" />
    </template>
  </div>
</template>
